// Imported from the types module rather than the folder barrel: the barrel
// pulls in the whole visual component tree, which would stop the pure-geometry
// assert script from running standalone.
import { CmarkdownvisualType } from '../Cmarkdownvisual/Cmarkdownvisual.types';

export const QUADRANT_VISUAL_TYPE = CmarkdownvisualType.Quadrant;
export const QUADRANT_METRIC_UNIT = 'ITEMS';

// The chart is laid out once into a fixed box and scaled by the SVG viewBox,
// matching the sequence renderer's approach.
export const VIEW_WIDTH = 720;
export const VIEW_HEIGHT = 520;
// Left margin carries the rotated y-axis ends; bottom carries the x-axis ends;
// top carries the title.
export const MARGIN_LEFT = 58;
export const MARGIN_RIGHT = 30;
export const MARGIN_TOP = 52;
export const MARGIN_BOTTOM = 52;

export const TITLE_Y = 30;
export const TITLE_FONT_SIZE = 16;
export const AXIS_LABEL_FONT_SIZE = 12;
export const CORNER_LABEL_FONT_SIZE = 12;
export const POINT_LABEL_FONT_SIZE = 12;

export const POINT_RADIUS = 6;
export const POINT_HALO_RADIUS = 12;
// Gap between a dot and its label, and the inset of a corner label from its
// corner of the plot box.
export const POINT_LABEL_GAP = 11;
export const CORNER_LABEL_INSET = 14;
// Keeps a label baseline off the plot edge when a point sits at 0 or 1.
export const LABEL_EDGE_PADDING = 10;
export const POINT_LABEL_BASELINE_OFFSET = 4;
export const AXIS_LABEL_GAP = 18;
export const Y_AXIS_LABEL_ROTATION = -90;
export const NO_ROTATION = 0;

export const ACCENT = '#66FEC1';
export const POINT_HALO_FILL = 'rgba(102, 254, 193, 0.14)';
export const PLOT_BORDER = 'rgba(255, 255, 255, 0.12)';
export const MIDLINE_STROKE = 'rgba(255, 255, 255, 0.09)';
export const PLOT_FILL = 'rgba(255, 255, 255, 0.02)';
export const TITLE_COLOR = 'rgba(255, 255, 255, 0.88)';
export const POINT_LABEL_COLOR = 'rgba(255, 255, 255, 0.82)';
export const AXIS_LABEL_COLOR = 'rgba(255, 255, 255, 0.45)';
export const CORNER_LABEL_COLOR = 'rgba(255, 255, 255, 0.32)';

export const PLOT_BORDER_WIDTH = 1;
export const PLOT_CORNER_RADIUS = 8;
export const MIDLINE_WIDTH = 1;

// Compact tile — a miniature of the same four-quadrant box.
export const COMPACT_VIEW_SIZE = 100;
export const COMPACT_INSET = 12;
export const COMPACT_POINT_RADIUS = 3.2;
export const COMPACT_POINT_OPACITY = 0.9;
